import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobService } from 'src/app/services/job.service';
import { Store } from '@ngxs/store';
import { SharedService } from 'src/app/services/shared.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CollectService } from 'src/app/services/collect.service';
import { setTimeout$ } from 'src/app/core/common';

@Component({
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {
  target: string;
  referrer: string;
  showSubscribe = false;
  job: any;
  user: any;
  jobClickId: string;
  isSponsored: boolean;

  constructor(private route: ActivatedRoute, private sharedService: SharedService, private collectService: CollectService,
    private analyticsService: AnalyticsService, private jobService: JobService, private store: Store, private router: Router) { }

  async ngOnInit() {
    // this.sharedService.setNoIndex();
    await this.load();
  }

  private async load() {
    this.referrer = this.sharedService.isBrowser ? document.referrer : '/job';
    var params = this.route.snapshot.params;

    var idOrUrl = params['id'] || decodeURIComponent(atob(params['url']));
    this.jobClickId = this.route.snapshot.queryParams['jcid'];
    this.isSponsored = !!this.route.snapshot.queryParams['sp'];

    var result = await this.jobService.getTarget(idOrUrl);

    if (!result?.job) {
      const searchRedirect = JobService.getExpiredRedirect(null);
      if (this.sharedService.isBrowser) this.router.navigateByUrl(searchRedirect);
      else this.sharedService.redirectPermanent(searchRedirect);
      return;
    }

    this.target = result.target;
    this.job = result.job;
    this.user = this.store.selectSnapshot(state => state.auth.user);

    if (!result.redirect) {
      if (this.isSponsored)
        await this.redirect();
      else if (this.sharedService.isAlreadySubscribed ||
        (this.user && this.user.Seeker && this.user.Seeker.JobAlertSettings && this.user.Seeker.JobAlertSettings.Searches.length > 0))
        setTimeout$(async () => await this.redirect(), 1500);
      else {
        this.showSubscribe = true;
      }
    }
    else this.sharedService.redirectPermanent(this.target);
  }

  async redirect(withSubscribe = false) {
    this.analyticsService.gtmEvent('do-redirect-A', 'seeker',
      withSubscribe
        ? 'new-subscribe'
        : (this.showSubscribe ? 'no-subscribe' : 'old-subscribe'));

    setTimeout$(() => window.location.replace(this.target), 1000);
    this.analyticsService.gtmEvent(this.isSponsored ? 'job-list-redirect' : 'job-redirect', 'seeker', this.job?.SourceName);
    await this.collectService.jobClickRedirected(this.jobClickId, this.job.Id, this.isSponsored);
  }
}
